module.exports = __webpack_public_path__ + "static/media/googleG2.77133ed9.png";